const config = {
    development: {
        baseURL: 'https://dev-api.zilieai.com',
        timeout: 180000,
    },
    production: {
        baseURL: 'https://api.zilieai.com',
        timeout: 180000,
    },
    test: {
        baseURL: 'https://test-api.zilieai.com',
        timeout: 180000,
    },
    pre: {
        baseURL: 'https://pre-api.zilieai.com',
        timeout: 180000,
    },
}
// 优先使用 VUE_APP_ENV（仅 build:test 会用到），其他场景仍用 NODE_ENV（保持兼容）
const env = process.env.VUE_APP_ENV || process.env.NODE_ENV
export default config[env]
